import { useToast } from "@/hooks/use-toast"
import { useLocale } from '@/i18n/LocaleProvider';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()
  const { locale } = useLocale();

  return (
    <ToastProvider label={locale === 'pt-BR' ? 'Notificação' : 'Notification'}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose aria-label={locale === 'pt-BR' ? 'Fechar' : 'Close'} />
          </Toast>
        )
      })}
      <ToastViewport label={locale === 'pt-BR' ? 'Notificações ({hotkey})' : 'Notifications ({hotkey})'} />
    </ToastProvider>
  )
}
